import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CypressDirective } from './cypress.directive';

@NgModule({
  declarations: [CypressDirective],
  imports: [CommonModule],
  exports: [CypressDirective],
})
export class CypressDirectiveModule {}
